import { initSupportItems } from "./support-items.js";


function initSupportPageModules() {
    if (!document.querySelector('.support-distribution')) return;

    initSupportItems();
}

window.onload = () => {
    initSupportPageModules();
}